<template>
    <UCard
        id="forgot-password-card"
        class="hidden flex-1 flex-col"
        :ui="{
            background: 'bg-white dark:bg-gray-800',
            divide: 'divide-y divide-gray-100 dark:divide-gray-800',
            ring: '',
            body: { base: 'flex-1' },
            header: {
                background: 'py-[29px] shadow-md bg-blue-600 dark:bg-gray-900'
            }
        }">
        <template #header>
            <div class="flex items-center justify-between">
                <h3 class="text-lg leading-6 text-white">Reset Password</h3>

                <UButton color="white" variant="outline" size="sm" icon="i-bi-x" class="-my-1 text-white" @click="toggleLogin" />
            </div>
        </template>

        <UCard>
            <UAuthForm
                title="Forgot password?"
                align="top"
                icon="i-bi-person-exclamation"
                :fields="passwordFields"
                :schema="resetPasswordSchema"
                :submit-button="{ label: 'Reset Password', color: 'green', size: 'xl', icon: 'i-bi-person-exclamation', leading: true }"
                :loading="loading"
                @submit="handleResetPasswordForm"
                :ui="{
                    base: 'text-center',
                    title: 'text-2xl text-blue-600 dark:text-white font-bold',
                    description: 'text-sm text-dark-800 dark:text-gray-400 mt-1',
                    icon: {
                        wrapper: 'mb-2 pointer-events-none',
                        base: 'w-16 h-16 flex-shrink-0 text-green-600 dark:text-white'
                    },
                    footer: 'text-xs text-gray-500 dark:text-gray-400 mt-2 text-center'
                }">
                <template #description>
                    Back to
                    <NuxtLink
                        class="cursor-pointer font-medium text-dark-950 underline underline-offset-2 hover:no-underline dark:text-white"
                        @click="rememberedPassword"
                        >Login</NuxtLink
                    >.
                </template>

                <template #reset_email-help>Please enter your email address and we will send you a link to reset your password</template>
            </UAuthForm>

            <!--<NuxtTurnstile v-model="token" />-->
        </UCard>
    </UCard>
</template>

<script setup>
    import { z } from 'zod'

    const { toggleLogin, loading } = inject('login')
    const { resetPasswordForEmail } = useAuthentication()
    const { capitalize, lowercase } = useHelpers()
    const { showSuccessMessage, showErrorMessage } = useMessages()
    // const token = ref('')

    const rememberedPassword = () => {
        document.getElementById('login-card').classList.remove('hidden')
        document.getElementById('forgot-password-card').classList.add('hidden')
    }

    const passwordFields = [
        {
            type: 'email',
            name: 'reset_email',
            label: 'Email',
            icon: 'i-bi-envelope-at',
            placeholder: 'Enter your email',
            size: 'lg',
            eagerValidation: true
        }
    ]

    const resetPasswordSchema = z.object({
        reset_email: z.string().email('Please provide a valid email address')
    })

    const showLoading = () => {
        loading.value = true
    }

    const clearLoading = () => {
        loading.value = false
    }

    const handleResetPasswordForm = async (data) => {
        try {
            showLoading()

            const email = lowercase(data.reset_email).trim()

            await resetPasswordForEmail({
                email: email
                // captchaToken: token.value
            })

            data.reset_email = ''

            clearLoading()
            toggleLogin()

            showSuccessMessage('Reset Link Sent!', `We have sent you a reset password link to ${email}. Please check your Junk and Spam folders.`)
        } catch (error) {
            console.error('DEBUG: Handle Reset Password Form Error: ', error.message)
            clearLoading()

            data.reset_email = ''

            showErrorMessage('Error!', capitalize(error.message))
        }
    }
</script>
